// @flow
export { default } from './MainMobileHeadItem';



// WEBPACK FOOTER //
// ./src/components/main/MainMobileHeadItem/index.js